import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import colors, { WHITE, BLACK, RADICAL_RED, PORCELAIN_2 } from '@/constants/colors';

export const Container = styled.div`
  position: relative;
  padding: 16px 8px;
  border-radius: 4px;
  background-color: ${WHITE};
  transition: all 0.4s;
  box-shadow: 4px 4px 16px ${rgba(BLACK, 0.1)};
  text-align: center;

  display: flex;
  flex-direction: column;

  &.service-card--full-height {
    height: 100%;
  }

  &.service-card,
  .service-card {
    &__plan-chip {
      position: absolute;
      top: 4px;
      right: 4px;
    }

    &__arr-date-chip {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border-radius: 4px 4px 0 0;
      font-size: 1.1rem;
    }

    &__addon-item {
      position: absolute;
      top: 5px;
      right: 5px;

      img {
        height: 24px;
      }
    }

    &__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 80px;
      margin-bottom: 12px;

      img {
        max-width: 100%;
        max-height: 80px;
        width: auto;
      }
    }

    &__deal-price {
      display: flex;
      flex-direction: column;
      align-items: center;

      .service-card__old-cost {
        position: relative;
        line-height: 1.9rem;
        margin-bottom: -2px;

        &:before {
          content: '';
          position: absolute;
          right: -3px;
          left: -3px;
          top: 50%;
          transform: translate(0, -50%);
          height: 1px;
          background-color: ${RADICAL_RED};
        }

        strong {
          font-weight: 400;
        }
      }
    }

    &__cost {
      strong {
        font-weight: 500;
      }
    }

    &__additional-price {
      display: inline-block;

      &-icon {
        font-size: 24px;
        margin-bottom: -6px;
      }
    }

    &__main-info {
      height: 100%;
      min-height: 71px;

      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .price__content {
        flex: 1;
      }

      .seasons-info {
        justify-self: flex-end;
      }

      .price__content + .seasons-info {
        margin-top: 12px;
      }
    }

    &__partial-season {
      font-weight: 600;
      color: ${colors.textSecondary};
    }

    &__availbles {
      margin-bottom: 10px;

      &-item {
        font-size: 14px;
        line-height: 16px;
        padding: 5px 0;
        font-weight: 600;
        border-bottom: 1px solid ${PORCELAIN_2};

        &:last-of-type {
          border-bottom: none;
        }
      }
    }

    &__button {
      width: 100%;
      max-width: 160px;
      margin: 0 auto;
      padding: 1.3rem 1rem;
    }

    &__link {
      font-size: 1.4rem;
      line-height: 1.4rem;
    }

    .buttons-apps-list {
      margin: 0 -4px;

      .MuiButton-sizeSmall {
        font-size: 1.2rem;
        line-height: 1.2rem;
      }
    }
  }
`;

export const SeasonsInfoStyled = styled.div`
  /* height: 48px; */

  .seasons-info {
    &__title,
    &__desc {
      text-transform: capitalize;
    }

    &__title {
      height: 24px;
      overflow: hidden;
    }
  }
`;

export const LinkWrapper = styled.div`
  margin: 0 -8px 12px;

  flex: 1;

  > a {
    padding: 0 8px;
  }

  > a:not(.service-card__button) {
    width: 100%;
    height: 100%;
    color: inherit;
    text-decoration: none;

    display: flex;
    flex-direction: column;
  }
`;
